<template>
    <div class="top_box">
        <div class="item" v-for="item,key in list" v-text="item.text"></div>
    </div>
</template>

<script>

module.exports = {
    components: {},
    data() {
        return {
            list     : [],
            last_text: '',
        }
    },
    created() {

    },
    methods: {
        log() {
        },
        show_box(text, time) {
            var item = {text, time}
            if (this.last_text == text) {
                return
            }
            this.last_text = text
            setTimeout(() => {
                this.last_text = ''
            }, 1000)
            this.list.push(item)
            setTimeout(() => {
                this.list = this.list.filter(i => i !== item)
            }, (time || 3) * 1000)
        },
    }
}
</script>

<style scoped>
.top_box {
    position: fixed;
    top: 0rem;
    left: 0rem;
    width: 100%;
    height: 0%;
    background: #000000aa;
    z-index: 100;
}

.top_box .item {
    width: 100%;
    text-align: center;
    color: #fff;
    background: #000000aa;
    font-size: 0.35rem;
}
</style>